import { combineReducers } from 'redux';
import user from './user/user.js';
import nav from './nav/nav.js';
import crud from './crud/crud.js';
import order from './order/order.js';
import workstation from './workstation/workstation.js';
import planning from './planning/planning.js';
import dashboard from './dashboard/dashboard.js';
import notification from './notification/notification.js';

const rootReducer = combineReducers({
  user,
  nav,
  crud,
  order,
  workstation,
  planning,
  dashboard,
  notification
});

// const rootReducer = (initialState, state,action) => {
  
//     state = initialState;
// }

export default rootReducer; 

